import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

import Home from './pages/home'
import Solution from './pages/solution'
import Introduction from './pages/introduction'
import Help from './pages/help'
import Examples from './pages/examples'
import News from './pages/news'
import About from './pages/about'

Vue.use(VueRouter)

window.eventBus = new Vue();//注册全局事件对象

Vue.config.productionTip = false

const routes = [{
  path: '/', redirect: '/home'
}, {
  path: '/home', component: Home, name: 'home'
}, {
  path: '/solution:index?', component: Solution, name: 'solution'
}, {
  path: '/introduction:index?', component: Introduction, name: 'introduction'
}, {
  path: '/help:index?', component: Help, name: 'help'
}, {
  path: '/examples:index?', component: Examples, name: 'examples'
}, {
  path: '/news/:id?', component: News, name: 'news'
}, {
  path: '/about:index?', component: About, name: 'about'
}]

const router = new VueRouter({
  routes
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
